import React, { useContext, useState } from 'react'
import PropTypes from 'prop-types'
import { context } from '@/Layout'
import ContainerLinks from './containerLinks'
import { motion, AnimatePresence } from 'framer-motion'
import AnimationHeader from './AnimationHeader'
import useUtils from '@/hooks/useUtils'
import { get } from 'lodash'
import { useLocation } from 'react-router-dom'
import RenderImgHeader from './RenderImgHeader'
// styles
import '../styles.header.scss'

const MenuHeader = (props) => {
  const { iconLogo } = props
  const [hoverLink, setHoverLink] = useState(null)
  const { pathname } = useLocation()
  const { device } = useUtils()
  const { isOpened, appState } = useContext(context)

  const menusHeader = get(appState, ['menus', 'main-menu'], [])

  const changeHoverLink = (linkHover) => {
    if (device === 'desktop') setHoverLink(linkHover)
  }

  return (
    <AnimatePresence>
      {isOpened ? (
        <motion.div className="menuHeader ">
          {device === 'desktop' ? (
            <AnimationHeader duration={1.2}>
              <RenderImgHeader
                key={`img_${hoverLink ? hoverLink : pathname}`}
                link={hoverLink ? hoverLink : pathname}
              />
            </AnimationHeader>
          ) : null}
          <AnimationHeader duration={1.4} delay={0.2}>
            <ContainerLinks
              key={`containerLisnk_${isOpened}`}
              isOpened={isOpened}
              iconLogo={iconLogo}
              menusHeader={menusHeader}
              changeHoverLink={changeHoverLink}
            />
          </AnimationHeader>
        </motion.div>
      ) : null}
    </AnimatePresence>
  )
}

MenuHeader.propTypes = {
  iconLogo: PropTypes.any,
}

export default MenuHeader
